import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { MYCLAIMSSUMMARYCHART_INIT_LOADING, MYCLAIMSSUMMARYCHART_INIT_SUCCESS, MYCLAIMSSUMMARYCHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  myClaimsSummaryChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {
}

const actions = {
  async initMyClaimsSummaryChart({ commit, state }, data) {
    commit(MYCLAIMSSUMMARYCHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.myClaimsSummaryChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(MYCLAIMSSUMMARYCHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(MYCLAIMSSUMMARYCHART_INIT_FAIL)
      }
    } else {
      commit(MYCLAIMSSUMMARYCHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [MYCLAIMSSUMMARYCHART_INIT_LOADING](state) {
    state.myClaimsSummaryChart.init = 0
  },
  [MYCLAIMSSUMMARYCHART_INIT_SUCCESS](state, data) {
    const { myClaimsSummaryChart } = state
    myClaimsSummaryChart.menu = data.menu
    myClaimsSummaryChart.init = 1
    myClaimsSummaryChart.lastUpdated = new Date()
    myClaimsSummaryChart.scope = data.scope
    myClaimsSummaryChart.appId = data.appId
    myClaimsSummaryChart.info = data.info
    myClaimsSummaryChart.appIds = data.appIds
    Vue.set(myClaimsSummaryChart, 'chartInfo', data.chartInfo)
  },
  [MYCLAIMSSUMMARYCHART_INIT_FAIL](state) {
    state.myClaimsSummaryChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
